<template>
  <v-card>
    <v-card-title primary-title>{{formTitle}}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="3">
          <v-text-field label="Name" v-model="name" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="cancel"> Cancel </v-btn>
      <v-btn color="primary" @click="saveSchemaConfig"> Save </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">

import { manageSchemasAPI, SavedSchemaConfigDTO } from "@/services/schemas/manageSchemasAPI";
import { ref } from "vue";
import { withLoadingScreen } from "@/lib/loading";

const { schemaConfig } = defineProps<{
  schemaConfig?: SavedSchemaConfigDTO
}>();

const formTitle = schemaConfig ? "Edit Schema Config" : "Create Schema Config";
const name = ref<string>(schemaConfig ? schemaConfig.name : "");

  const emit = defineEmits<{
    (e: 'cancelForm' ): void,
    (e: 'schemaConfigSaved', savedSchemaConfig: SavedSchemaConfigDTO);
  }>()

function cancel() {
  emit("cancelForm");
}

async function saveSchemaConfig() {
  await withLoadingScreen(async () => {
    let savedSchemaConfig: SavedSchemaConfigDTO;
    if (schemaConfig) {
      savedSchemaConfig = await updateSchemaConfig();
    } else {
      savedSchemaConfig = await createSchemaConfig();
    }
    emit("schemaConfigSaved", savedSchemaConfig);
  });
}

async function createSchemaConfig(): Promise<SavedSchemaConfigDTO> {
  const unsavedSchemaConfig = {
    name: name.value
  };
  return await manageSchemasAPI.createSchemaConfig(unsavedSchemaConfig);
}

async function updateSchemaConfig(): Promise<SavedSchemaConfigDTO> {
  const schemaConfigToUpdate: SavedSchemaConfigDTO = {
    ...schemaConfig!,
    name: name.value
  };
  return await manageSchemasAPI.updateSchemaConfig(schemaConfigToUpdate.id!, schemaConfigToUpdate);
}

</script>
